import { Button } from '@/components/_ui/Button'
import { Input } from '@/components/_ui/Input'
import { useTranslate } from '@/components/Helpers/Translate'
import { cn } from '@/lib/utils'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'
import React, { useCallback, useEffect, useRef } from 'react'
import debounce from 'lodash.debounce'

export const HeaderSearchBar = () => {
  const {
    app: { isSearchBarActive },
    setApp,
  } = useGlobalStore()
  const { translate } = useTranslate()

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!isSearchBarActive) {
      setApp({ searchBarValue: '' })

      if (inputRef.current) {
        inputRef.current.value = ''
      }
    }

    if (isSearchBarActive) {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 500)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef, isSearchBarActive])

  const handleDebounceFunction = async (search: string) => {
    setApp({ searchBarValue: search })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFunction = useCallback(
    debounce(handleDebounceFunction, 500),
    [],
  )

  const handleSearchChange = async (search: string) => {
    await debounceFunction(search)
  }

  return (
    <div
      style={
        isSearchBarActive
          ? { height: '100px', transition: '300ms' }
          : {
              height: '0px',
              opacity: 0,
              transition: '200ms',
              pointerEvents: 'none',
            }
      }
      className={cn(
        'm-auto flex max-w-4xl items-center justify-center space-x-3 px-5 ease-in-out',
      )}
    >
      <Input
        type="search"
        onChange={(event) => {
          ;(async () => {
            await handleSearchChange(event.currentTarget.value)
          })().catch(() => {})
        }}
        ref={inputRef}
        iconLeft={
          <Image
            height={20}
            width={20}
            alt={translate('search')}
            src="/icons/search.svg"
          />
        }
        label={translate('search')}
      />
      <Button
        onClick={() => setApp({ isSearchBarActive: false, searchBarValue: '' })}
        variant="ghost"
      >
        <Image
          className="rotate-45"
          alt={translate('close')}
          height={25}
          width={25}
          src="/icons/plus.svg"
        />
      </Button>
    </div>
  )
}
